import { Plugin } from 'ckeditor5/src/core';
import { MgnlLinkCommand } from './mgnllinkcommand';
import util from './mgnllinkutil';
import { MgnlLinkButtonCommand } from './mgnllinkbuttoncommand';
import MgnlLinkUI from './mgnllinkui';

export default class MgnlLink extends Plugin {
	public static get pluginName() {
		return 'MgnlLink' as const;
	}

	public static MGNL_GET_LINK_EVENT = 'mgnlGetLink';
	public MGNL_RESOURCE_SELECTED_EVENT = 'mgnlLinkSelected';
	public static MGNL_LINK_ATTRIBUTE = 'mgnlLink';

	/**
	 * @inheritDoc
	 */
	public static get requires() {
		return [ MgnlLinkUI ] as const;
	}

	public init(): void {
		this._defineSchema();
		this._defineConverters();
		this._defineCommands();
		this._defineEventListenerCallback();
	}

	private _defineSchema() {
		// extend the schema with a new attribute 'MgnlLink.MGNL_LINK_ATTRIBUTE'.
		// the selected text that has this attribute will be linked to mgnl selected resource.
		this.editor.model.schema.extend( '$text', {
			allowAttributes: MgnlLink.MGNL_LINK_ATTRIBUTE
		} );
	}

	private _defineConverters() {
		// Convert html <a> tag to the $text node which has the model attribute 'MgnlLink.MGNL_LINK_ATTRIBUTE'.
		this.editor.conversion.for( 'upcast' ).elementToAttribute( {
			view: 'a',
			model: {
				key: MgnlLink.MGNL_LINK_ATTRIBUTE,
				value: ( viewElement: any ) => {
					const href = viewElement.getAttribute( 'href' );
					if ( href ) {
						if ( util.isMgnlLink( href ) ) {
							return href;
						}
					}
				}
			},
			converterPriority: 'high'
		} );

		// Convert model mgnlLink attribute to HTML <a> tag (downcast)
		this.editor.conversion.for( 'downcast' ).attributeToElement( {
			model: MgnlLink.MGNL_LINK_ATTRIBUTE,
			view: ( mgnlLinkValue, { writer } ) => {
				if ( !mgnlLinkValue ) {
					return null;
				}

				// Check if this is a DAM asset URL and should open in new tab
				const attributes: { href: string; target?: string } = {
					href: mgnlLinkValue
				};

				// For DAM assets, add target="_blank" to open in new tab
				if ( typeof mgnlLinkValue === 'string' && mgnlLinkValue.includes( '/dam/jcr:' ) ) {
					attributes.target = '_blank';
				}

				// Create an anchor element with appropriate attributes
				return writer.createAttributeElement( 'a', attributes, {
					priority: 5
				} );
			},
			converterPriority: 'high'
		} );
	}

	private _defineCommands() {
		this.editor.commands.add( MgnlLinkButtonCommand.COMMAND_NAME, new MgnlLinkButtonCommand( this.editor ) );
		this.editor.commands.add( MgnlLinkCommand.COMMAND_NAME, new MgnlLinkCommand( this.editor ) );
	}

	private _defineEventListenerCallback( ) {
		const editor = this.editor;
		// listen to the mgnlLinkSelected event. Create a link to the selected resource
		editor.on( this.MGNL_RESOURCE_SELECTED_EVENT, ( evt, data ) => {
			// insert event data to the editor
			editor.execute( MgnlLinkCommand.COMMAND_NAME, data );
			editor.editing.view.focus();
		} );
	}
}
